import { useScreenSize } from "hooks";
import DesktopLayout from "./desktop";
import MobileLayout from "./mobile";
import { getTokenFromLocalStore } from "utils/localstore";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AuthenticatedLayout() {
  const { isDesktop, isMobile } = useScreenSize();
  const navigate = useNavigate();

  useEffect(() => {
    const token = getTokenFromLocalStore("access_token");
    if (!token) {
      navigate("/auth");
    }
  }, [navigate]);

  let layoutContent;

  switch (true) {
    case isMobile:
      layoutContent = <MobileLayout />;
      break;
    case isDesktop:
      layoutContent = <DesktopLayout />;
      break;
    default:
      layoutContent = <MobileLayout />;
  }

  return layoutContent;
}
